import { render, staticRenderFns } from "./SelectDealer.vue?vue&type=template&id=66b7f9fa&"
import script from "./SelectDealer.vue?vue&type=script&lang=ts&"
export * from "./SelectDealer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b7f9fa')) {
      api.createRecord('66b7f9fa', component.options)
    } else {
      api.reload('66b7f9fa', component.options)
    }
    module.hot.accept("./SelectDealer.vue?vue&type=template&id=66b7f9fa&", function () {
      api.rerender('66b7f9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectDealer.vue"
export default component.exports